import {IStore} from '../interfaces/store';

export function showLegendSelector(state: IStore): boolean {
  return state.showLegend;
}
